import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import FullTable from "components/FullTable"
import Title from "../general/title"
import numeral from "numeral"
import helpers from "helpers/helpers"
import moment from "moment"
import settings from 'settings'

class SpecsAveragePricing extends Component {
	constructor(props) {
		super(props)
		this.state = {
			filters: {},
			columns: [
				{
					Header: "Community",
					accessor: "Community",
					filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
				},
				{
					Header: "Lot Type",
					accessor: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
				},
				{
					Header: "Builder",
					accessor: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
				},
				{
					Header: "",
					accessor: "blank1",
					width: 40,
					className: "spacer",
					filterable: false,
				},
				{
					Header: "# of Starts",
					accessor: "# of Starts",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v["# of Starts"]
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Marketing Price Range",
					accessor: "Starts Marketing Price Range",
				},
				{
					Header: "Avg Marketing Price",
					accessor: "Starts Avg Marketing Price",
				},
				{
					Header: "",
					accessor: "blank2",
					className: "spacer",
					width: 40,
					filterable: false,
				},
				{
					Header: "# Complete",
					accessor: "# of Complete",
					Footer: (props) => {
						let total = 0
						_.forEach(props.data, (v) => {
							total += v["# of Complete"]
						})
						if (typeof total == "number") {
							return total.toLocaleString()
						}
						return total
					},
				},
				{
					Header: "Marketing Price Range",
					accessor: "Complete Marketing Price Range",
				},
				{
					Header: "Avg Marketing Price",
					accessor: "Complete Avg Marketing Price",
				},
			],
			feedColumns: [
				{
					Header: "Community",
					accessor: "Community",
					filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
				},
				{
					Header: "Neighborhood",
					accessor: "Neighborhood",
					filterMethod: (f, r) => helpers.tableText(f, r, "Neighborhood"),
				},
				{
					Header: "Lot Type",
					accessor: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
				},
				{
					Header: "Builder",
					accessor: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
				},
				{
					Header: "Address",
					accessor: "Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "Address"),
				},
				{
					Header: "Marketing Price",
					accessor: "Marketing Price",
				},
				{
					Header: "Square Feet",
					accessor: "Square Feet",
					Cell: (v) => {
						if (v.value) {
							return numeral(v.value).format("0,0")
						}
						return ""
					},
				},
				{
					Header: "Stories",
					accessor: "Stories",
				},
				{
					Header: "Beds",
					accessor: "Beds",
				},
				{
					Header: "Full Baths",
					accessor: "Full Baths",
				},
				{
					Header: "Half Baths",
					accessor: "Half Baths",
				},
				{
					Header: "Garage",
					accessor: "Garage",
				},
				{
					Header: "Status",
					accessor: "Status",
					filterMethod: (f, r) => helpers.tableText(f, r, "Status"),
				},
				{
					Header: "Move In",
					accessor: "Move In",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
				{
					Header: "Start Date",
					accessor: "Start Date",
					Cell: (props) => {
						if (props.value) {
							return moment.unix(props.value).format("MM/DD/YY")
						}
						return ""
					},
					filterMethod: (f, r) => helpers.dateFilter(f, r),
					sort: "desc",
				},
				{
					Header: "Model",
					accessor: "Model",
					filterMethod: (f, r) => helpers.tableText(f, r, "Model"),
				},
			],
			openHousesColumns: [
				{
					Header: "Community",
					accessor: "Community",
					filterMethod: (f, r) => helpers.tableText(f, r, "Community"),
				},
				{
					Header: "Lot Type",
					accessor: "Lot Type",
					filterMethod: (f, r) => helpers.tableText(f, r, "Lot Type"),
				},
				{
					Header: "Builder",
					accessor: "Builder",
					filterMethod: (f, r) => helpers.tableText(f, r, "Builder"),
				},
				{
					Header: "User",
					accessor: "User",
					filterMethod: (f, r) => helpers.tableText(f, r, "User"),
				},
				{
					Header: "Address",
					accessor: "Address",
					filterMethod: (f, r) => helpers.tableText(f, r, "Address"),
				},
				{
					Header: "Date",
					accessor: "Date",
					Cell: (v) => {
						if (v.value) {
							return `${moment.unix(v.value.start).format("dddd, MMM D h:mm")} - ${moment
								.unix(v.value.end)
								.format("h:mm")}`
						}
						return ""
					},
					sortMethod: (a, b) => {
						try {
							if (a.start > b.start) return 1
							if (a.start < b.start) return -1
						} catch (e) {
							console.log(e)
							return 0
						}
						return 0
					},
				},
			],
			sorted: [],
		}
	}

	buildTable() {
		let store = {}
		let ret = []

		let model = {
			numStarts: 0,
			numComplete: 0,
			startsLowPrice: 0,
			startsHighPrice: 0,
			completeLowPrice: 0,
			completeHighPrice: 0,
			startsGross: 0,
			completeGross: 0,
			hasPriceStart: 0,
			hasPriceComplete: 0, // these HAS variables really aren't different than gross..they were in there when marketing price wasn't skipping below
		}

		_.forEach(this.props.payload.exec.lots, (v) => {
			if (
				v.lot_status == "Closed" ||
				v.lot_status == "Contract" ||
				!v.start_date ||
				!v.marketing_price ||
				!v.builder
			) {
				return
			}
			if (!v.in_feed && !v.in_feed_manual) return
			if (v.move_in_date) {
				//v.complete_date = v.move_in_date
			}
			let path = `${v.property}.${v.lot_type}.${v.builder}`
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model), Object)
			}

			// Starts
			if (v.start_date && !v.complete_date) {
				store[v.property][v.lot_type][v.builder].hasPriceStart++
				store[v.property][v.lot_type][v.builder].startsGross += v.marketing_price
				if (
					v.marketing_price <= store[v.property][v.lot_type][v.builder].startsLowPrice ||
					!store[v.property][v.lot_type][v.builder].startsLowPrice
				) {
					store[v.property][v.lot_type][v.builder].startsLowPrice = v.marketing_price
				}
				if (v.marketing_price >= store[v.property][v.lot_type][v.builder].startsHighPrice) {
					store[v.property][v.lot_type][v.builder].startsHighPrice = v.marketing_price
				}

				store[v.property][v.lot_type][v.builder].numStarts++
			}
			// Completes
			if (v.complete_date) {
				store[v.property][v.lot_type][v.builder].hasPriceComplete++
				store[v.property][v.lot_type][v.builder].completeGross += v.marketing_price
				if (
					v.marketing_price <= store[v.property][v.lot_type][v.builder].completeLowPrice ||
					!store[v.property][v.lot_type][v.builder].completeLowPrice
				) {
					store[v.property][v.lot_type][v.builder].completeLowPrice = v.marketing_price
				}
				if (v.marketing_price >= store[v.property][v.lot_type][v.builder].completeHighPrice) {
					store[v.property][v.lot_type][v.builder].completeHighPrice = v.marketing_price
				}
				store[v.property][v.lot_type][v.builder].numComplete++
			}
		})
		//console.log(store)
		_.forEach(store, (prow, pid) => {
			_.forEach(prow, (typeRow, tid) => {
				_.forEach(typeRow, (v, bid) => {
					let type = _.find(this.props.payload.public.lot_types, { id: parseInt(tid) })
					let builder = _.find(this.props.payload.public.builders, { id: parseInt(bid) })
					//console.log(v, bid, builder)
					let property = _.find(this.props.payload.public.properties, { id: parseInt(pid) })
					let startAvg = numeral(v.startsGross / v.hasPriceStart).format("$0,0")
					let completeAvg = numeral(v.completeGross / v.hasPriceComplete).format("$0,0")
					ret.push({
						"Lot Type": type.name,
						Builder: builder.name,
						Community: property.name,
						"# of Starts": v.numStarts,
						"# of Complete": v.numComplete,
						"Starts Marketing Price Range": `${numeral(v.startsLowPrice).format("$0,0")} - ${numeral(
							v.startsHighPrice
						).format("$0,0")}`,
						"Complete Marketing Price Range": `${numeral(v.completeLowPrice).format("$0,0")} - ${numeral(
							v.completeHighPrice
						).format("$0,0")}`,
						"Starts Avg Marketing Price": startAvg,
						"Complete Avg Marketing Price": completeAvg,
					})
				})
			})
		})
		//console.log(ret)
		//console.log(store)
		return ret
	}

	buildFeedTable() {
		let homes = []
		_.forEach(this.props.payload.exec.lots, (v) => {
			let p = _.find(this.props.payload.public.properties, { id: parseInt(v.property) })
			let lt = _.find(this.props.payload.public.lot_types, { id: parseInt(v.lot_type) })
			let b = _.find(this.props.payload.public.builders, { id: parseInt(v.builder) })
			let neigh = _.find(this.props.payload.public.neighborhoods, { id: parseInt(v.neighborhood) })
			let status = ""
			if (settings.preferMoveInOverComplete) {
				if (v.move_in_date && v.move_in_date < moment().unix()) status = "Complete"
				else if (v.start_date) status = "Under Construction"
			}
			else {
				if (v.complete_date) status = "Complete"
				else if (v.start_date) status = "Under Construction"
			}
			if ((v.in_feed === 1 || v.in_feed_manual === 1) && v.start_date > 0 && !v.sale_date) {
				homes.push({
					Community: p ? p.name : "",
					"Lot Type": lt ? lt.name : "",
					Builder: b ? b.name : "",
					Address: v.address,
					"Square Feet": v.sqft,
					Stories: v.stories,
					Beds: v.beds,
					"Full Baths": v.full_baths,
					"Half Baths": v.half_baths,
					"Move In": v.move_in_date,
					Garage: v.garage,
					Status: status,
					Neighborhood: neigh ? neigh.name : "",
					"Marketing Price": numeral(v.marketing_price).format("$0,0"),
					"Start Date": v.start_date,
					Model: v.model ? "Yes" : "No",
				})
			}
		})

		return homes
	}

	buildOpenHouses() {
		let homes = []
		_.forEach(this.props.payload.exec.lots, (v) => {
			if (!v.open_house) return
			_.forEach(v.open_house, (r) => {
				let p = _.find(this.props.payload.public.properties, { id: parseInt(v.property) })
				let lt = _.find(this.props.payload.public.lot_types, { id: parseInt(v.lot_type) })
				let b = _.find(this.props.payload.public.builders, { id: parseInt(v.builder) })
				let user = _.find(this.props.payload.users, { id: parseInt(r.user) })
				homes.push({
					Community: p ? p.name : "",
					"Lot Type": lt ? lt.name : "",
					Builder: b ? b.name : "",
					Address: v.address,
					Date: r.times,
					User: user ? `${user.first} ${user.last}` : "",
				})
			})
		})

		return homes
	}

	render() {
		if (!this.props.payloadStatus) {
			return ""
		} else {
			return (
				<div className="sales">
					<div className="imageGroup">
						<Title title="Specs-Average Pricing" showDate={false} />
						<div className="content">
							<p className="mid">
								This data reflects Starts and Complete Spec Home Listings as shown on the Community's
								Website. The number of completes is based on the Complete Date and not the Move In Date
								from the builder feed.
							</p>
							<FullTable
								data={this.buildTable()}
								columns={this.state.columns}
								name="specsAveragePricing"
								title="Specs Average Pricing"
								classNames="small"
								pageSize={20}
							/>
						</div>
					</div>
					<div className="imageGroup">
						<div className="content">
							<h2>Spec Home Listings</h2>
							<p className="mid">
								This data reflects the Current Spec Homes as shown on the Community's Website.
							</p>
							<FullTable
								data={this.buildFeedTable()}
								columns={this.state.feedColumns}
								name="spec__feedColumns"
								title="Spec Home Listings"
								pageSize={20}
								classNames="small"
								defaultSorted={[
									{
										id: "Start Date",
										desc: true,
									},
								]}
							/>
							<h2>Open Houses</h2>
							<FullTable
								data={this.buildOpenHouses()}
								columns={this.state.openHousesColumns}
								name="spec__openHousesColumns"
								title="Open Houses"
								pageSize={20}
								classNames="small"
							/>
						</div>
					</div>
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(SpecsAveragePricing)
